import * as Yup from 'yup';
import { prettyFloatMoney } from '@/helpers/utils';
import i18n from '@/i18n';

const { t } = i18n;

export const getValidationSchema = ({
  min_group_a,
  min_group_b,
  max_group_a,
  max_group_b,
  addOnly,
  min_total,
  total_cash_without_bonus,
  total_bonus_amount,
}) => {
  return Yup.object({
    group_a_amount: Yup.number()
      .min(
        min_group_a,
        addOnly
          ? t('investing:allocate_form.validation_min_amount', {
              amount: prettyFloatMoney(min_group_a),
            })
          : t('investing:allocate_form.validation_min_bonus', {
              amount: prettyFloatMoney(min_group_a),
            }),
      )
      .max(
        max_group_a,
        t('investing:allocate_form.validation_max_amount', {
          amount: prettyFloatMoney(max_group_a),
        }),
      )
      .required(t('investing:allocate_form.required_field')),
    group_b_amount: Yup.number()
      .min(
        min_group_b,
        t('investing:allocate_form.validation_min_amount', {
          amount: prettyFloatMoney(min_group_b),
        }),
      )
      .max(
        max_group_b,
        t('investing:allocate_form.validation_max_amount', {
          amount: prettyFloatMoney(max_group_b),
        }),
      )
      .test(
        'cash-limit',
        t('investing:allocate_form.validation_no_cash_group_b'),
        function (value) {
          const { group_a_amount } = this.parent;
          const cashUsedByA = Math.max(0, (group_a_amount || 0) - total_bonus_amount);
          const cashAvailableForB = total_cash_without_bonus - cashUsedByA;
          return (value || 0) <= cashAvailableForB;
        },
      )
      .required(t('investing:allocate_form.required_field')),
  }).test(
    'total-minimum',
    t('investing:allocate_form.min_investment_amount', {
      amount: prettyFloatMoney(min_total),
    }),
    function (values) {
      const { group_a_amount, group_b_amount } = values;
      const total =
        (Number(group_a_amount) || 0) + (Number(group_b_amount) || 0);
      return total >= min_total;
    },
  );
};
